export const supabaseConnectionsResource = {
  name: 'Supabase Connections',
  fields: {
    name: 'Name',
    description: 'Description',
    environment: 'Environment',
    supabaseUrl: 'Supabase URL',
    serviceKey: 'Service Key',
    // anonKey: 'Anon Key', -- removed, not used in system
    databaseUrl: 'Database URL',
    isActive: 'Active',
    isDefault: 'Default Connection',
    status: 'Status',
    credentials: 'Credentials',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    lastTested: 'Last Tested',
    createdBy: 'Created By',
  },
  list: {
    subtitle: 'Manage Supabase connections for OCPP servers',
    filters: {
      activeOnly: 'Active Only',
    },
  },
  create: {
    title: 'Create Supabase Connection',
    subtitle: 'Configure a new Supabase connection for OCPP servers',
  },
  edit: {
    title: 'Edit Supabase Connection',
    subtitle: 'Update connection configuration and credentials',
  },
  show: {
    subtitle: 'View connection details and manage linked servers',
  },
  sections: {
    basic: 'Basic Information',
    credentials: 'Credentials',
    settings: 'Settings',
    metadata: 'Metadata',
    connectedServers: 'Connected OCPP Servers',
    connectionDetails: 'Connection Details',
  },
  helpers: {
    name: 'A descriptive name for this connection',
    description: 'Optional description for this connection',
    environment: 'Select the environment for this connection',
    supabaseUrl: 'The Supabase project URL (https://xxxx.supabase.co)',
    serviceKey: 'Service role key with full database access',
    // anonKey: 'Anonymous key for public API access', -- removed, not used in system
    databaseUrl: 'PostgreSQL connection string (optional)',
    isActive: 'Enable or disable this connection',
    isDefault: 'Use this as the default connection for new servers',
    updateServiceKey: 'Leave empty to keep existing key',
    // updateAnonKey: 'Leave empty to keep existing key', -- removed, not used in system
    updateDatabaseUrl: 'Leave empty to keep existing URL',
  },
  placeholders: {
    leaveEmpty: 'Leave empty to keep existing value',
  },
  statuses: {
    active: 'Active',
    inactive: 'Inactive',
  },
  actions: {
    testConnection: 'Test Connection',
    testing: 'Testing...',
    updateCredentials: 'Update Credentials',
    cancelUpdate: 'Cancel Update',
    assignServers: 'Assign Servers',
    unlinkServer: 'Unlink',
    assign: 'Assign',
  },
  info: {
    credentials: 'All credentials will be encrypted before storage',
    existingCredentials: 'Existing credentials are encrypted and secure',
  },
  warnings: {
    credentialUpdate: 'Updating credentials will affect all connected OCPP servers',
  },
  messages: {
    noConnectedServers: 'No OCPP servers are connected to this Supabase instance',
    noAvailableServers: 'No available OCPP servers to assign',
    connectionSuccess: 'Connection successful!',
    connectionFailed: 'Connection failed',
  },
  badges: {
    primary: 'Primary',
    serviceKey: 'Service Key',
    databaseUrl: 'Database URL',
  },
  environments: {
    production: 'Production',
    staging: 'Staging',
    development: 'Development',
    uat: 'UAT',
  },
  confirmations: {
    unlinkServer: 'Are you sure you want to unlink this server?',
  },
  dialogs: {
    assignServers: {
      title: 'Assign OCPP Servers',
      info: 'Select OCPP servers to connect to this Supabase connection. You can designate one server as primary.',
    },
  },
};

export const supabaseConnections = {
  supabaseConnections: supabaseConnectionsResource,
};